import React from 'react';
import { createStyles } from './styles';

export interface DateStatusProps {
  type: 'TERMINATED' | 'ACTIVE';
  date: string;
}

const DateStatus = ({ type, date }: DateStatusProps): JSX.Element => {
  const classes = createStyles(type === 'TERMINATED');

  switch (type) {
    case 'TERMINATED':
      return <p className={classes.tag}>{date ? `Terminated on ${date}` : 'Terminated'}</p>;
    case 'ACTIVE':
      return <p className={classes.tag}>{date ? `Active until ${date}` : 'Active'}</p>;
    default:
      return <></>;
  }
};

export default DateStatus;
